import moment from 'moment';

class ArrivalDashboardController {

    constructor(dataApiService, loadingService) {
        this.dataApiService = dataApiService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.loadingService.startLoading(['today', 'tomorrow']);

        return this.getArrivals();
    }

    getArrivals () {
        return Promise.all([
            this.getData('today').then(response => {
                this.loadingService.stopLoading('today');
                this.today = response;
            }),
            this.getData('tomorrow').then(response => {
                this.loadingService.stopLoading('tomorrow');
                this.tomorrow = response;
            })
        ]);
    }

    getData (scope) {
        let date = moment();

        if (scope === 'tomorrow') {
            date = date.add(1, 'day');
        }

        return this.dataApiService.getData('arrivals', date.format('YYYY-MM-DD'));
    }
}
ArrivalDashboardController.$inject = ['dataApiService', 'loadingService'];

export default ArrivalDashboardController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/controllers/arrival.dashboard.controller.js